<script setup>
/**
 * ZoomLogo — Zoom's blue video-camera app mark, as inline SVG, with an
 * optional lowercase "zoom" wordmark in the brand blue.
 */
defineProps({
  size: { type: [Number, String], default: 40 },
  withWordmark: { type: Boolean, default: false },
})
</script>

<template>
  <span class="zoom-logo" role="img" aria-label="Zoom">
    <svg
      :width="size"
      :height="size"
      viewBox="0 0 40 40"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="40" height="40" rx="9" fill="#0e72ed" />
      <!-- Camera body -->
      <rect x="7.5" y="13" width="16" height="14" rx="3.2" fill="#fff" />
      <!-- Lens / viewfinder wedge -->
      <path
        d="M25.5 17.4l5.4-3.6c.9-.6 2.1.04 2.1 1.12v10.16c0 1.08-1.2 1.72-2.1 1.12l-5.4-3.6z"
        fill="#fff"
      />
    </svg>
    <span v-if="withWordmark" class="zoom-logo__wordmark">zoom</span>
  </span>
</template>

<style scoped>
.zoom-logo {
  display: inline-flex;
  align-items: center;
  gap: var(--space-3);
}
.zoom-logo__wordmark {
  font-family: var(--font-zoom);
  font-size: 1.5rem;
  font-weight: 900;
  letter-spacing: -0.02em;
  color: #0e72ed;
}
[data-theme='dark'] .zoom-logo__wordmark {
  color: #4f9bff;
}
</style>
